// extracted by mini-css-extract-plugin
export default {"link":"style_link__08wyK","centerGrid":"style_centerGrid__tqRLW","img":"style_img__Us9JX","namegame":"style_namegame__vMcEr"};